import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function PhoneOff({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>PhoneOff</title>
      <path
        d="M19 5L5 19"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.92852 13.0108C7.65912 12.6403 7.40976 12.2629 7.17931 11.8813L9.15183 9.90876C9.56557 9.49502 9.74516 8.90188 9.63041 8.32812L8.89615 4.6568C8.73255 3.8388 8.01432 3.25 7.18013 3.25H5.03382C4.05999 3.25 3.2153 4.06956 3.32917 5.11226C3.55018 7.13598 4.22086 9.6771 5.58614 12.1242C5.95625 12.7876 6.37791 13.4449 6.85595 14.0833L7.92852 13.0108ZM7.81286 15.2477C9.05539 16.6262 10.6011 17.8681 12.5059 18.8268C14.3022 19.7308 16.405 20.3763 18.8537 20.6517C19.8965 20.7689 20.7499 19.9336 20.7499 18.9334V16.7808C20.7499 15.9778 20.2034 15.2778 19.4244 15.083L16.7311 14.4097C16.1348 14.2606 15.5039 14.4354 15.0692 14.87L12.7033 17.2359C11.1708 16.3934 9.908 15.3435 8.87505 14.1855L7.81286 15.2477ZM19.0213 19.161C17.1698 18.9529 15.5498 18.5201 14.1343 17.9263L16.1299 15.9307C16.192 15.8686 16.2821 15.8436 16.3673 15.8649L19.0606 16.5382C19.1719 16.5661 19.2499 16.6661 19.2499 16.7808V18.9334C19.2499 19.0884 19.1264 19.1729 19.0213 19.161ZM8.09117 8.8481L6.43456 10.5047C5.48495 8.53564 4.99569 6.55533 4.82031 4.94942C4.81485 4.89947 4.82983 4.85642 4.86492 4.81922C4.90224 4.77964 4.96096 4.75 5.03382 4.75H7.18013C7.2993 4.75 7.4019 4.83412 7.42528 4.95097L8.15954 8.6223C8.17593 8.70426 8.15028 8.789 8.09117 8.8481Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
